import React, {useState, useEffect,useCallback,useContext} from 'react';
import api from '../contexts/BaseUrl'
import './Sales.css'
import LeftPanel from '../components/LeftPanel';
import SearchIcon from '../icons/SearchIcon';
import CrossIcon from '../icons/CrossIcon';
import {Spinner} from 'react-activity'
import "react-activity/dist/library.css";
import Loading from '../components/Loading';
import { UnitShadeContext } from "../contexts/UnitShadeContext";


function Sales(){

    const token = JSON.parse(localStorage.getItem('auth')).token;
    const userRole = JSON.parse(localStorage.getItem('auth')).role;
    const { unitShadeNo } = useContext(UnitShadeContext);

    const [addSale, setAddSale ]= useState(0);
    const [editSale,setEditSale] = useState(0);
    const [editSaleDetails, setEditSaleDetails] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isAddError,setIsAddError] = useState(false);
    const [isDeleteError, setIsDeleteError] = useState(false);
    const [isDeleteLoading, setIsDeleteLoading] = useState(false);
    const [isEditLoading, setIsEditLoading] = useState(false);

    const [allSales, setAllSales] = useState([]);
    const [saleId, setSaleId] = useState(0);

    //search variable
    const [searchSalesAssignedTo, setSearchSalesAssignedTo] = useState('');
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('');

    const dateFromObj = dateFrom ? new Date(dateFrom) : null;
    const dateToObj = dateTo ? new Date(dateTo) : null;
    
    const [pageNumber, setPageNumber] = useState(1);
    const [pagination, setPagination] = useState([]);

    //add new sale variable
    const [selectedDate, setSelectedDate] = useState('');
    const selectedDateObj = selectedDate ? new Date(selectedDate) : null;
    
    
    const [saleTo, setSaleTo] = useState('');
    const [saleToPhone,setSaleToPhone] = useState('');
    const [saleDescription, setSaleDescription] = useState('');
    const [totalQuantity, setTotalQuantity] = useState('');
    const [saleRate, setSaleRate] = useState('');
    const [totalPrice,setTotalPrice] = useState(0);
    const [paid, setPaid] = useState(0);
    const [note,setNote] = useState('');
    
    

  
   

  
    var url;

    if(dateFromObj != null && dateToObj != null && searchSalesAssignedTo.length>0){
       
            url = `sales/get-all-sales?unitShadeId=${unitShadeNo}&saleToPhone=${searchSalesAssignedTo}&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=20`
        
        
    }
    else if(dateFromObj != null && dateToObj != null){
        
            url = `sales/get-all-sales?unitShadeId=${unitShadeNo}&fromDate=${dateFrom}&toDate=${dateTo}&pageNumber=${pageNumber}&pageSize=20`
        
        
    }
    else if(dateFromObj != null && searchSalesAssignedTo.length>0){
        
            url = `sales/get-all-sales?unitShadeId=${unitShadeNo}&saleToPhone=${searchSalesAssignedTo}&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=20`
             
    }
    else if(dateFromObj != null){
        
            url = `sales/get-all-sales?unitShadeId=${unitShadeNo}&fromDate=${dateFrom}&pageNumber=${pageNumber}&pageSize=20`
             
    }
    else if(searchSalesAssignedTo.length>0){
        
            url = `sales/get-all-sales?unitShadeId=${unitShadeNo}&saleToPhone=${searchSalesAssignedTo}&pageNumber=${pageNumber}&pageSize=20`
           
    }
    
    else{
        url = `sales/get-all-sales?unitShadeId=${unitShadeNo}&pageNumber=${pageNumber}&pageSize=20` ;
    }


    const handlePageNext = () =>{
        if(pagination.totalPages>pagination.currentPage){
            setPageNumber(pageNumber+1)
        }     
    }

    const handlePagePrevious = () =>{
        if(pageNumber>1){
            setPageNumber(pageNumber-1);
        }
    }

   
    const fetchAllSales = useCallback(async () => {
        setIsLoading(true);
        await api.get(url,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setAllSales(response.data);
            setIsLoading(false);
            setPagination(JSON.parse(response.headers.pagination));
        }).catch(err =>{
            setIsLoading(false);
        })
    },[url, token])

    const fetchSaleDetails = (e) => {
        setIsEditLoading(true);
        api.get(`sales/get-sale-details?saleId=${e}`,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setSaleId(response.data.saleId);
            setSelectedDate(response.data.saleDate);
            setSaleDescription(response.data.saleDescription);
            setSaleTo(response.data.saleTo);
            setSaleToPhone(response.data.saleToPhone);
            setTotalQuantity(response.data.saleTotalQuantity);
            setSaleRate(response.data.saleRate);
            setTotalPrice(response.data.saleTotalPrice);
            setPaid(response.data.salePaid);
            
            setNote(response.data.saleNote);
            setIsEditLoading(false);
        }).catch(err =>{
            setIsEditLoading(false);
        })
    }

    useEffect(() => {
       fetchAllSales();
    },[fetchAllSales])


    const closeAddSale = () => {
        setSelectedDate('');
        setSaleDescription('');
        setSaleTo('');
        setSaleToPhone('');
        setTotalQuantity();
        setSaleRate();
        setTotalPrice();
        setPaid();
        
        setNote('');
        setIsAddError(false);
        setAddSale(0);
    }

    const handleAddSales = async (e) => {
        
        e.preventDefault();
        setIsLoading(true);

        await api.post(`sales/create-sale`,{
            saleDate: selectedDateObj,
            saleTo: saleTo,
            saleToPhone:saleToPhone,
            saleDescription: saleDescription,
            saleTotalQuantity: totalQuantity,
            saleRate: saleRate,
            saleTotalPrice: totalPrice,
            salePaid: paid,
            saleNote: note,
            unitShadeId:unitShadeNo
        },{
            headers:{
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            
            setSelectedDate('');
            setSaleDescription('');
            setSaleTo('');
            setSaleToPhone('');
            setSaleRate('');
            setTotalQuantity('');
            setTotalPrice(0);
            setPaid(0);
            setNote('');
            setAddSale(0);
            fetchAllSales();
            setIsLoading(false);
        }).catch(err =>{
            setIsAddError(true);
            setIsLoading(false);
           
           
        })
    }

    const showEditSale = (e) => {
        fetchSaleDetails(e);
        setEditSaleDetails(1);
    }

    const closeEditSale = () => {
        setSelectedDate('');
        
        setSaleTo('');
        setSaleToPhone('');
        setSaleDescription('');
        setSaleRate('');
        setTotalQuantity('');
        setTotalPrice(0);
        setPaid(0);
        
        setNote('');
        setIsEditLoading(false);
        fetchAllSales();
        setEditSaleDetails(0);
    }

    const handleEditSale = async (e) => {
        e.preventDefault();
        setIsEditLoading(true);
        await api.post(`sales/edit-sale`,{
            saleId: saleId,
            saleTo: saleTo,
            saleToPhone:saleToPhone,
            saleDescription: saleDescription,
            saleTotalQuantity: totalQuantity,
            saleRate: saleRate,
            saleTotalPrice: totalPrice,
            salePaid: paid,
            saleNote: note
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setSaleDescription('');
            setSaleTo('');
            setSaleToPhone('');
            setSaleRate('');
            setTotalQuantity('');
            setTotalPrice();
            setPaid();
           
            setNote('');
            setIsEditLoading(false);
            fetchAllSales();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsError(true);
            //setIsLoading(false);
            setSelectedDate('');
            setSaleDescription('');
            setSaleTo('');
            setSaleToPhone('');
            setSaleRate('');
            setTotalQuantity('');
            setTotalPrice();
            setPaid();
            
            setNote('');
        })
    }

    const handleDeleteSale = async (e) => {
        e.preventDefault();
        setIsDeleteLoading(true);
        await api.post(`sales/delete-sale`,{
            saleId: saleId,
        },{
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            setSelectedDate('');
            setSaleDescription('');
            setSaleTo('');
            setSaleToPhone('');
            setTotalQuantity('');
            setSaleRate('');
            setTotalPrice();
            setPaid();
          
            setNote('');
            setIsDeleteLoading(false);
            fetchAllSales();
            setEditSaleDetails(0);
        }).catch(err => {
            setIsDeleteError(true);
            setIsDeleteLoading(false);
            setSelectedDate('');
            setSaleDescription('');
            setSaleTo('');
            setSaleToPhone('')
            setSaleRate('');
            setTotalQuantity('');
            setTotalPrice(0);
            setPaid(0);
            
            setNote('');
        })
    }
 
    return(
        <div className='salesPage'> 
    
           <LeftPanel 
                tabName='sales'
           />
           <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='searchAddBox'>
                        <div className='dateBox'>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateFrom(e.target.value)}
                                value={dateFrom}
                            />
                            <div id='to'>To</div>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateTo(e.target.value)}
                                value={dateTo}
                            />

                            <div id='searchBox'>
                                <SearchIcon 
                                    size='24' 
                                    style={{
                                        paddingLeft:10,
                                        paddingTop:8,
                                        position:'absolute',
                                    }} 
                                    color='gray'
                                />
                                <input
                                    placeholder='Search by Sale to or Phone or Description'
                                    id='searchSales'
                                    onChange={(e) => setSearchSalesAssignedTo(e.target.value)}
                                    value={searchSalesAssignedTo}
                                />
                            </div>
                        </div>
                       <div>
                            
                           
                        {userRole === 'Admin' && 
                        <>
                           {
                           editSale === 0 ?
                           <button 
                                id='editButton'
                                onClick={() => setEditSale(1)}
                            >Edit Sales</button>
                       :
                            <button 
                                id='editCancelButton'
                                onClick={() => setEditSale(0)}
                            >Cancel Edit</button>
                           }
                           
                            <button 
                                id='addButton'
                                onClick={() => setAddSale(1)}
                            >Add Sales</button>
                        </>
                        }
                       </div>
                        
                    </div>
                    <div id='tableBox'>
                        {isLoading ? 
                        <Loading /> :
                        <table>
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Sale to</th>
                                    <th>Sale to Phone</th>
                                    <th>Sales Description</th>
                                    <th>Total Quantity</th>
                                    <th>Rate (Tk)</th>
                                    <th>Total Price (Tk)</th>
                                    <th>Paid (Tk)</th>
                                   
                                    <th>Note</th>
                                    {editSale === 1 && <th>Actions</th>}
                                </tr>
                            </thead>
                            <tbody>
                            {allSales.map((item, index) =>{
                                return(
                                    <tr key={index}>
                                        <td>{item.saleDate.substring(0,item.saleDate.length-9)}</td>
                                        <td>{item.saleTo}</td>
                                        <td>{item.saleToPhone}</td>
                                        <td>{item.saleDescription}</td>
                                        <td>{item.saleTotalQuantity}</td>
                                        <td>{item.saleRate}</td>
                                        <td>{item.saleTotalPrice}</td>
                                        <td>{item.salePaid}</td>
                                        
                                        <td>{item.saleNote}</td>
                                        {editSale ===1 && <td onClick={() => showEditSale(item.saleId)} style={{cursor:'pointer'}}>Edit</td>}
                                        
                                    </tr>
                                )
                            })}
                            </tbody>

                        </table>
                    }
                    <div id='pageChangeBox'>
                        <div id='fixedBox'>
                            <button id='pageChangeButton' onClick={handlePagePrevious}>Back</button>
                            
                            <span>{pageNumber} / {pagination.totalPages}</span>
                            <button id='pageChangeButton' onClick={handlePageNext}>Next</button>
                        </div>    
                        
                    </div>
                    </div>
                </div>
           </div>
           {
               addSale === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            cursor:'pointer'
                        }}
                        onClick={closeAddSale}
                    />
                    <form id='modalContent' onSubmit={handleAddSales}>
                        <div id='modalName'>Add New Sale</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <input
                                    id='typeName'
                                    type='date'
                                    required
                                    onChange={(e) => setSelectedDate(e.target.value)}
                                    value={selectedDate}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Sale to:</div>
                                <input
                                    id='typePhone'
                                    placeholder='Sale Person Name'
                                    required
                                    onChange={(e) => setSaleTo(e.target.value)}
                                    value={saleTo}
                                />
                            </div>
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Sales Description:</div>
                                <textarea
                                    rows="4"
                                    cols="25"
                                    id='typeAddress'
                                    placeholder='Type Description'
                                    required
                                    onChange={(e) => setSaleDescription(e.target.value)}
                                    value={saleDescription}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Sale to Phone:</div>
                                <input
                                    id='typePhone'
                                    type='number'
                                    placeholder='Type Phone no'
                                    required
                                    onChange={(e) => setSaleToPhone(e.target.value)}
                                    value={saleToPhone}
                                />
                            </div>
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Quantity:</div>
                                <input
                                    id='typeTotalQuantity'
                                    placeholder='Total Quantity'
                                    required
                                    onChange={(e) => setTotalQuantity(e.target.value)}
                                    value={totalQuantity}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Rate (Tk):</div>
                                <input
                                    id='typePhone'
                                    
                                    placeholder='price per piece'
                                    required
                                    onChange={(e) => setSaleRate(e.target.value)}
                                    value={saleRate}
                                />
                            </div>
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Price (Tk): </div>
                               
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Total Price Here'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>    
                            <div id='name'>
                                <div id='header'>Paid(Tk) : </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Amount Paid'
                                    required
                                    onChange={(e) => setPaid(e.target.value)}
                                    value={paid}
                                />
                            </div> 
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            
                            <div id='name'>
                                <div id='header'>Note:</div>
                                <input
                                    id='typePhone'
                                    placeholder='Anything to add?'
                                    required
                                    onChange={(e) => setNote(e.target.value)}
                                    value={note}
                                />
                            </div>
                        </div>
                        {isAddError && 
                            <div id='errorMsg'>Failed adding new sale! Please try again later.</div>
                        }
                        {isLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Add Sale</button>
                    }
                       
                    </form>
                </div>
               </>
           }
            {
               editSaleDetails === 1 && 
               <>
                <div id='darkBackground' />
                <div id='modal'>
                    {isEditLoading ? 
                    <Loading /> :
                    
                    <div>
                    <CrossIcon 
                        size='36'
                        style={{
                            position:'absolute',
                            right:0,
                            top:0,
                            cursor:'pointer'
                        }}
                        onClick={closeEditSale}
                    />
                    <form id='modalContent' onSubmit={handleEditSale}>
                        <div id='modalName'>Edit Sale</div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='nameTitle'>Date:</div>
                                <div>{selectedDate.substring(0,selectedDate.length-9)}</div>
                            </div>
                            <div id='name'>
                                <div id='header'>Sale to:</div>
                                <input
                                    id='typePhone'
                                    placeholder='Sale Person Name'
                                    required
                                    onChange={(e) => setSaleTo(e.target.value)}
                                    value={saleTo}
                                />
                            </div>
                        </div>
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='addressTitle'>Sales description:</div>
                                <textarea
                                    rows="4"
                                    cols="25"
                                    id='typeAddress'
                                    placeholder='Type Address Here'
                                    required
                                    onChange={(e) => setSaleDescription(e.target.value)}
                                    value={saleDescription}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Sale to Phone:</div>
                                <input
                                    id='typePhone'
                                    placeholder='Phone No'
                                    required
                                    onChange={(e) => setSaleToPhone(e.target.value)}
                                    value={saleToPhone}
                                />
                            </div>
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Quantity:</div>
                                <input
                                    id='typeDesignation'
                                    placeholder='Small Product Number'
                                    required
                                    onChange={(e) => setTotalQuantity(e.target.value)}
                                    value={totalQuantity}
                                />
                            </div>
                            <div id='name'>
                                <div id='header'>Rate (Tk):</div>
                                <input
                                    id='typePhone'
                                    placeholder='Rate'
                                    required
                                    onChange={(e) => setSaleRate(e.target.value)}
                                    value={saleRate}
                                />
                            </div>
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            <div id='name'>
                                <div id='header'>Total Price (Tk): </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Total Price Here'
                                    required
                                    onChange={(e) => setTotalPrice(e.target.value)}
                                    value={totalPrice}
                                />
                            </div>    
                            <div id='name'>
                                <div id='header'>Paid(Tk) : </div>
                                <input
                                    id='typeDesignation'
                                    type='number'
                                    placeholder='Amount Paid'
                                    required
                                    onChange={(e) => setPaid(e.target.value)}
                                    value={paid}
                                />
                            </div> 
                        </div>
                        <div id='separationLine' />
                        <div id='namePhone'>
                            
                            <div id='name'>
                                <div id='header'>Note:</div>
                                <input
                                    id='typePhone'
                                    
                                    placeholder='Anything to add?'
                                    required
                                    onChange={(e) => setNote(e.target.value)}
                                    value={note}
                                />
                            </div>
                        </div>
                        {isError && 
                            <div id='errorMsg'>Failed updating sale! Please try again later.</div>
                        }
                        {isDeleteError && 
                            <div id='errorMsg'>Failed deleting sale! Please try again later.</div>
                        }
                        {isEditLoading ? 
                    <button id='addEmployee'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                    <button id='addEmployee'>Update Sale</button>
                    }
                    
                    </form>
                    {isDeleteLoading ?    
                        <button id='deleteSale'><Spinner size={12} color='black' style={{display:'block', margin:'auto'}} /></button>    :
                        <button id='deleteSale' onClick={handleDeleteSale} >Delete</button>
                    }
                    </div>
                    }
                </div>
               </>
           }
          

        </div>
    )
}

export default Sales;